import React from "react";
import Loadable from "react-loadable";
import { Redirect } from "react-router-dom";
import { isLoggedIn } from "../util/authHelper";
import { isMobile } from "react-device-detect";
const Loader = <div style={{
  background: '#ffffff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  textAlign: 'center',
  height: '100vh',
  margin: 'auto',
}}>Loading....</div>

const IMPORTS = {
  LOGIN: import("../components/login/loginComponent.jsx"),
  LOGIN_AUTH_SERVICE: import("../components/login/loginAuthServiceComponent.jsx"),
  AUTH_REDIRECT: import("../components/oauth2/OAuth2RedirectHandler.jsx"),
  SIGN_UP: import("../components/signup/signupComponent.jsx"),
  PWD_FORGOT: import("../components/common/forgotPassword.jsx"),
  PWD_RESET: import("../components/common/resetPassword.jsx"),
  PWD_UPDATED: import("../components/common/passwordUpdated.jsx"),
  USER_UNVERIFY: import("../components/common/unverifiedUser.jsx"),
  EMAIL_VERIFY: import("../components/common/verifyUser.jsx"),
  HOME: import("../components/home/homeComponent"),
  DASHBOARD: import("../containers/DashboardContainer.jsx"),
  INVITATION: import("../components/common/invitation.jsx"),
  WELCOME: import("../components/common/welcome.jsx"),
  SIDE_VIEW: import("../containers/SideViewContainer.jsx"),
  COMPANY: import("../containers/CompanyContainer.jsx"),
  CREATE_COMPANY: import("../components/setupOrganisation/addCompany.jsx"),
  PAYMENT_SUCCESS: import("../components/company/manageBilling/paymentSuccess.jsx"),
  PAYMENT_FAILED: import("../components/company/manageBilling/paymentFailed.jsx"),
  CREATE_CLIENT: import("../components/setupOrganisation/createClientComponent.jsx"),
  // BILLING_HISTORY: import("../components/billing/billinghistory.jsx"),
  BILLING_DETAILS: import("../components/billing/billingdetails.jsx"),
  GST_DETAILS: import("../components/gstfile/gst-details.jsx"),
  GST_LIST: import("../components/gstfile/gst-list.jsx"),
  GST_ACTIVATION: import("../components/gstfile/gst-activation.jsx"),
  SUBSCRIBE: import("../components/setupOrganisation/subscribeBillingPlan.jsx"),
  UPLOAD_CSV: import("../components/dashboard/uploadCsv"),
  GST_AUTHENTICATION_SUCCESS: import("../components/gstfile/gstAuthenticationSuccess"),
  REPORTS: import("../components/reports"),
  BANK_STATEMENT: import("../components/bank-statement"),
}

const LoadableComponent = (commonProps, imports, isNeedAuth) =>
    Loadable({
      loader: () => imports,
      loading() {
        return Loader;
      },
      render(loaded, props) {
        let Component = loaded.default;
        if (isNeedAuth && !isLoggedIn()) {
          return <Redirect to="/login" />
        }
        return <Component {...props} commonProps={commonProps} />
      },
    })

export const ROUTES = [
  {
    path: "/login",
    id: "Login",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.LOGIN_AUTH_SERVICE),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/signup",
    id: "Signup",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.SIGN_UP),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/forgot-password",
    id: "ForgotPassword",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.PWD_FORGOT),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/password-updated",
    id: "PasswordUpdated",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.PWD_UPDATED),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/unverify-user",
    id: "UnverifyUser",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.USER_UNVERIFY),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/user/verifyEmail",
    id: "VerfiyEmail",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.EMAIL_VERIFY),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/welcome",
    id: "Welcome",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.WELCOME),
    header: false,
    headerText: "Vault",
  },
  {
    path: "/gst/redirect",
    id: "GSTAuthenticationSuccess",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_AUTHENTICATION_SUCCESS),
    header: true,
    headerText: "Vault",
  },
  {
    path: "/redirect/corppass",
    id: "GSTAuthenticationSuccess",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_AUTHENTICATION_SUCCESS),
    header: true,
    headerText: "Vault",
  },
  {
    path: "/",
    id: "Home",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.HOME, true),
    header: false,
    headerText: "Vault",
  },
]

export const PROTECTED_ROUTES = [
  {
    path: "/",
    id: "Dashboard",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.DASHBOARD),
    header: true,
    showCompany: true,
    companySelection: !isMobile,
    search: true,
    gstFilling: true,
    notification: true,
    menu: true,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/reset-password",
    id: "ResetPassword",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.PWD_RESET),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/invitation",
    id: "Invitation",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.INVITATION),
    header: false,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/document-side-view",
    id: "SideBySide",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.SIDE_VIEW),
    header: true,
    showCompany: true,
    companySelection: false,
    search: false,
    gstFilling: true,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/company/:subroute?",
    id: "Company",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.COMPANY),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/company/:team/integration",
    id: "AccountIntegration",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.COMPANY),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/create-company",
    id: "AddNewCompany",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.CREATE_COMPANY),
    header: false,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: false,
    headerText: "Vault",
  },
  {
    path: "/subscribe",
    id: "Subscribe",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.SUBSCRIBE),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    menu: false,
    setting: false,
    userMenu: false,
    headerText: "Vault",
  },
  {
    path: "/payment-success",
    id: "PaymentSuccess",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.PAYMENT_SUCCESS),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/payment-failed",
    id: "PaymentFailed",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.PAYMENT_FAILED),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/create-client",
    id: "CreateClient",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.CREATE_CLIENT),
    header: false,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: false,
    headerText: "Vault",
  },
  // {
  //   path: "/history",
  //   id: "History",
  //   component: commonProps =>
  //     LoadableComponent(commonProps, IMPORTS.BILLING_HISTORY),
  //   header: false,
  //   companySelection: false,
  //   search: false,
  //   gstFilling: false,
  //   notification: false,
  //   menu: false,
  //   setting:false,
  //   headerText: "Vault"
  // },
  {
    path: "/gst-detail",
    id: "GSTDetails",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_DETAILS),
    header: true,
    showCompany: true,
    companySelection: false,
    search: false,
    gstFilling: true,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/gst-list",
    id: "GSTList",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_LIST),
    header: true,
    showCompany: true,
    companySelection: !isMobile,
    search: false,
    gstFilling: false,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/activate-gst",
    id: "GSTActivation",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_ACTIVATION),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  // {
  //   path: "/gst/redirect",
  //   id: "GSTAuthenticationSuccess",
  //   component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_AUTHENTICATION_SUCCESS),
  //   header: true,
  //   showCompany: false,
  //   companySelection: false,
  //   search: false,
  //   gstFilling: false,
  //   notification: false,
  //   menu: false,
  //   setting: false,
  //   userMenu: true,
  //   headerText: "Vault",
  // },
  {
    path: "/redirect/corppass",
    id: "GSTCorppassAuthenticationSuccess",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.GST_AUTHENTICATION_SUCCESS),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: false,
    menu: false,
    setting: false,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/upload-csv",
    id: "UploadCSV",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.UPLOAD_CSV),
    header: true,
    showCompany: false,
    companySelection: false,
    search: false,
    gstFilling: false,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/business-pulse",
    id: "REPORTS",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.REPORTS),
    header: true,
    showCompany: true,
    companySelection: !isMobile,
    search: false,
    gstFilling: true,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
  {
    path: "/bank-statement",
    id: "BANK_STATEMENT",
    component: (commonProps) => LoadableComponent(commonProps, IMPORTS.BANK_STATEMENT),
    header: true,
    showCompany: true,
    companySelection: !isMobile,
    search: false,
    gstFilling: false,
    notification: true,
    menu: false,
    setting: true,
    userMenu: true,
    headerText: "Vault",
  },
]
